<template>
    <div class="wrapper">
        <el-form :model="form" ref="form" :rules="rules" style="width: 96%;margin: 10px auto">
            <el-form-item :label="$t('mis.emailSend.sendType')">即时发送</el-form-item>
            <el-form-item :label="$t('mis.emailSend.chooseTemplate')" prop="templateId" style="display: flex;" :disabled="isView">
                <el-select v-model="form.templateId" filterable placeholder="请选择模板"  @change="selectTemplate" style="width: 200%;" :disabled="isView">
                    <el-option value="" ></el-option>
                    <el-option v-for="item in templateList" :key="item.id" :label="item.templateName" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('mis.emailSend.title')" prop="title" style="display: flex;">
                <el-input v-model="form.title" style="width: 250%;" :disabled="isView"></el-input>
            </el-form-item>
            <el-form-item :label="$t('mis.emailSend.content')" prop="content" style="display: flex; margin-bottom: 2px">             
            </el-form-item>
            <editormd  ref="editormdRef" :emdData="emdData" :disabled="isView" prop="content"></editormd>
            <el-form-item :label="$t('mis.emailSend.attachment')" style="display: flex;">               
                <el-button @click="openAttUploadPop()" v-if="!isView">{{$t('mis.emailSend.selectAttachment')}}</el-button>     
                <ul>
                    <li v-for="(item, index) in this.attachFileList" :key="index">
                        {{ item.name }} ({{item.size}} bytes)
                    </li>
                </ul>       
                <ul>
			        <li v-for="(item, index) in this.sentAttachments" :key="index">
			            <a href="javascript:void(0);" style="color: blue;" @click="downloadAttachment(item.id, item.fileName)">{{item.fileName}}</a>
			        </li>
			    </ul>
            </el-form-item>   
            <el-form-item :label="$t('mis.emailSend.chooseChannel')" prop="channelId" style="display: flex;" :disabled="isView">
                <el-select v-model="form.channelId" filterable placeholder="" @change="selectChannel" style="width: 200%;" :disabled="isView">
                    <el-option v-for="item in channelList" :key="item.id" :label="item.channelName" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('mis.emailSend.sender')" prop="sender" style="display: flex;">
                <el-input v-model="form.sender" style="width: 250%;" :disabled=true></el-input>
            </el-form-item>     
            <el-form-item :label="$t('mis.emailSend.receiver')" prop="receiver" style="display: flex;">
                <el-input type="textarea" :rows="4" v-model="form.receiver" style="width: 300%;" :disabled="isView"></el-input>
                <el-button @click="openRecUploadPop()" v-if="!isView">{{$t('mis.bt.upload')+$t('mis.emailSend.emailList')}}</el-button>
                <el-button @click="downloadReceiverInCsv()" v-if="isView">{{$t('mis.bt.down')+$t('mis.emailSend.emailList')+"(csv)"}}</el-button>
                <el-button @click="downloadReceiverInTxt()" v-if="isView">{{$t('mis.bt.down')+$t('mis.emailSend.emailList')+"(txt)"}}</el-button>
            </el-form-item>
        </el-form>
        <template  slot="footer" style="display: flex;justify-content: center;align-items: center;width: 100%">
            <el-button @click="backToList()" >{{$t('page.cancel')}}</el-button>
            <el-button type="primary" @click="submit('form')" v-if="allowSubmit && !isView" :disabled="isSubmitting">{{$t('page.submit')}}</el-button>
        </template>

        <el-dialog :title="$t('mis.emailSend.uploadReceiver')" :visible.sync="receiverUploadVisible" :before-close="closeRecUploadPop">
            <el-upload ref="receiverUpload"  drag
                    :limit=receiverUploadLimitNum
                    :auto-upload="false"
                    accept=".txt,.csv"
                    :action="recUploadUrl()"
                    :before-upload="recBeforeUploadFile"
                    :on-change="recFileChange"
                    :on-remove="recHandleRemove"
                    :on-exceed="recExceedFile"
                    :on-success="recHandleSuccess"
                    :on-error="recHandleError"
                    :file-list="receiverUploadFileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">{{$t('mis.emailSend.uploadTip')}}<em>{{$t('mis.emailSend.uploadTip1')}}</em></div>
            <div class="el-upload__tip" slot="tip">{{$t('mis.emailSend.uploadTip2')}}</div>
            <div class="el-upload__tip" slot="tip">{{$t('mis.emailSend.uploadTip3')}}</div>
            <div class="el-upload__tip" slot="tip">{{$t('mis.emailSend.uploadTip4')}}</div>
            <div class="el-upload__tip" slot="tip">{{$t('mis.emailSend.uploadTip5')}}</div>
            </el-upload>
            <br/>
            <el-button size="small" type="primary" @click="recUploadFile">{{$t('mis.emailSend.uploadFile')}}</el-button>
        </el-dialog>

        <el-dialog :title="$t('mis.emailSend.selectAttachment')" :visible.sync="attachUploadVisible" :before-close="closeAttUploadPop">
            <el-upload ref="attachUpload"  drag
                    :auto-upload="false"
                    :multiple="true"
                    accept=".pdf"
                    :action="attUploadUrl()"
                    :on-change="attFileChange"
                    :on-remove="attHandleRemove"
                    :on-success="attHandleSuccess"
                    :on-error="attHandleError"
                    :file-list="attachFileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">{{$t('mis.emailSend.uploadTip')}}<em>{{$t('mis.emailSend.uploadTip1')}}</em></div>
            <div class="el-upload__tip" slot="tip">{{$t('mis.emailSend.uploadTip6')}}</div>
            <div class="el-upload__tip" slot="tip">{{$t('mis.emailSend.uploadTip7')}}</div>
            </el-upload>
            <br/>
            <el-button size="small" type="primary" @click="attUploadFile">{{$t('mis.bt.confirm')}}</el-button>
            <el-button size="small" type="primary" @click="attDelAllFile">{{$t('mis.emailSend.deleteAll')}}</el-button>
        </el-dialog>
    </div>
</template>

<script>
    import DataUtil from '@/views/mis/util/data'
    import editormd from "@/components/page/editor_md.vue"

    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import download from '@/utils/download'
    import axios from 'axios'
    import { getToken } from '@/utils/auth'
    import { getQueryString } from '@/utils/tools'

    export default {
        name: 'edit',
        components: {
            editormd
        },
        mounted(){      
            axios.post(URL.email.getTemplateList,"",{
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': getToken(getQueryString('label')),
                        },
                    }).then(
                        res=>{
                            if(res.data.code==0){
                                this.templateList = res.data.result;
                            }else{
                                this.$message.error(res.data.message);
                                this.backToList();
                            }
                        },err =>{
                            this.$message.error(err.message);
                            this.backToList();
                        }
                    );    
            if (this.$route.query.id){          
                axios.post(URL.email.getChannelList,"",{
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': getToken(getQueryString('label')),
                        },
                    }).then(
                        res=>{
                            if(res.data.code==0){
                                this.channelList = res.data.result;
                            }else{
                                this.$message.error(res.data.message);
                                this.backToList();
                            }
                        },err =>{
                            this.$message.error(err.message);
                            this.backToList();
                        }
                    );
                this.viewId = this.$route.query.id;
                let formData = new FormData();
                formData.append("id",this.$route.query.id);
                axios.post(URL.email.getEmailLogById,formData,{
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': getToken(getQueryString('label')),
                        },
                    }).then(
                        res=>{
                            if(res.data.code==0){
                                this.form = res.data.result;
                                let match = false;
                                for (let i in this.templateList) {
                                    if (this.templateList[i].id == this.form.templateId) {
                                        match = true;
                                        break;
                                    }
                                }
                                if (!match) {
                                    this.form.templateId = "";
                                }
                                match = false;
                                for (let i in this.channelList) {
                                    if (this.channelList[i].id == this.form.channelId) {
                                        match = true;
                                        break;
                                    }
                                }
                                if (!match) {
                                    this.form.channelId = "";
                                }
                                let contentMd = this.form.contentMd;
                                /*
                                this.emdData.editorConfig.onload = function() {
                                    //console.log('onload', this);
                                    this.setMarkdown(contentMd);
                                };
                                */
                                //用onload有時不能setMarkdown, 所以用setTimeout 1秒後setMarkdown
                                setTimeout(() => {  this.initMd(contentMd); }, 1000);
                                this.initAttachment();
                            }else{
                                this.$message.error(res.data.message);
                                this.backToList();
                            }
                        },err =>{
                            this.$message.error(err.message);
                            this.backToList();
                        }
                    );
            } else {                 
                axios.post(URL.email.getChannelList,"",{
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': getToken(getQueryString('label')),
                        },
                    }).then(
                        res=>{
                            if(res.data.code==0){
                                this.channelList = res.data.result;
                                this.form.channelId = this.channelList[0].id;
                                this.form.sender = this.channelList[0].emailAddress;
                            }else{
                                this.$message.error(res.data.message);
                                this.backToList();
                            }
                        },err =>{
                            this.$message.error(err.message);
                            this.backToList();
                        }
                    );
                this.allowSubmit = true;
            }
            if (this.$route.query.view) {
                this.isView = true;
                this.emdData.editorConfig.readOnly = true;
            }
        },
        methods: {
           backToList(){
               $("div#tags-view-container span.router-link-active span.el-icon-close").click();
               this.$router.push({path:"/mis/emailSend/list",query:{label:"MIS"}});
           },
           /*新增或跟提交数据触发事件*/
            submit(fromName){
                var invalidReceivers = this.validateReceiver(this.form.receiver);
                if (invalidReceivers.length > 0) {
                    this.$confirm('这些不是有效的电邮地址, 确定发送吗? ' + invalidReceivers.join(", "), '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.submitServer();
                    }).catch(() => {      
                        //this.$message.info('已取消发送');     
                    });
                } else {
                    this.submitServer();
                }           
            },
            submitServer(){
                this.isSubmitting = true;
                let formData = new FormData();
                for(let key in this.form){
                    formData.set(key,this.form[key]);
                    //console.log(formData.get(key));
                }
                let contentMd = this.$refs['editormdRef'].getMarkdown();
                let contentHtml = this.$refs['editormdRef'].getPreviewedHTML();
                formData.set("contentMd",contentMd);
                formData.set("contentHtml",contentHtml);
                for(let att in this.attachFileList){
                    formData.append("attachments", this.attachFileList[att]);
                }
                axios.post(URL.email.addEmailLog,formData,{
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': getToken(getQueryString('label')),
                    },
                }).then(
                    res=>{
                        if(res.data.code==0){
                            this.$message.success("操作成功");
                            this.backToList();
                        }else{
                            if (res.data.message.startsWith("msg_")) {
                                this.$message.error("操作失败");
                            } else {
                                this.$message.error(res.data.message);
                            }
                            this.isSubmitting = false;
                        }
                    },err =>{
                        //this.$message.error(err.message);
                        this.$message.error("操作失败");
                        this.isSubmitting = false;
                    }
                );
            },
            selectTemplate(){
                if (this.form.templateId) {
                    for (let i in this.templateList) {
                        if (this.templateList[i].id == this.form.templateId) {
                            this.$refs['editormdRef'].setMarkdown(this.templateList[i].contentMd);
                            this.form.title = this.templateList[i].title;
                        }
                    }
                } else {
                    this.$refs['editormdRef'].setMarkdown("");
                    this.form.title = "";
                }
            },     
            selectChannel(){
                for (let i in this.channelList) {
                    if (this.channelList[i].id == this.form.channelId) {
                        this.form.sender = this.channelList[i].emailAddress;
                    }
                }
            },              
            initMd(content) {
                this.$refs['editormdRef'].setMarkdown(content);
            },
            // 文件超出个数限制时的钩子
            recExceedFile(files, fileList) {
                this.$message.warning(`只能选择 ${this.receiverUploadLimitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`);
            },
            // 文件状态改变时的钩子
            recFileChange(file, fileList) {
                this.receiverUploadFileList.push(file.raw) ;
            },
            // 文件remove时的钩子
            recHandleRemove(file, fileList) {
                let index = this.receiverUploadFileList.indexOf(file);
                this.receiverUploadFileList.splice(index,1);
            },
            // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
            // this cannot trigger, therefore may need backend check
            recBeforeUploadFile(file) {
                let extension = file.name.substring(file.name.lastIndexOf('.')+1);
                //console.log("extension=" + extension);
                if(extension !== 'txt' && extension !== 'csv') {
                    this.$message.warning('只能上传后缀是.txt或.csv的文件');
                }
            },
            // 文件上传成功时的钩子
            recHandleSuccess(res, file, fileList) {
                this.$message.success('文件上传成功');
            },
            // 文件上传失败时的钩子
            recHandleError(err, file, fileList) {
                this.$message.error('文件上传失败');
            },
            recUploadUrl:function(){
                // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
                return ""
            },
            recUploadFile() {
                if (this.receiverUploadFileList.length === 0){
                    this.$message.warning('请上传文件');
                } else {
                    let form = new FormData();
                    let fileObj=this.receiverUploadFileList[0];
                    form.append('filename', fileObj);
                    //form.append(`name`, fileObj.name);
                    axios.post(URL.email.uploadReceiver,form,{
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': getToken(getQueryString('label')),
                        },
                        timeout: 20000,
                    }).then(
                        res=>{
                            if(res.data.code==0){                               
                                this.receiverUploadFileList=[];
                                this.form.receiver = res.data.result;
                                this.closeRecUploadPop();
                                var invalidReceivers = this.validateReceiver(this.form.receiver);
                                if (invalidReceivers.length > 0) {
                                    this.$alert("这些不是有效的电邮地址: " + invalidReceivers.join(", "));
                                } else {
                                    this.$message.success(window.$t('mis.emailSend.uploadSuc'));
                                }
                            }else{
                                //this.$message.error(window.$t('mis.emailSend.uploadFail'));
                                this.$message.error(res.data.message);
                            }
                        },err =>{
                            this.$message.error(window.$t('mis.emailSend.uploadFail'));
                        });
                }
            }, 
            /*关闭弹窗*/
            closeRecUploadPop() {
                this.receiverUploadVisible = false;
                //this.$refs.receiverUpload.clearFiles();
                this.receiverUploadFileList=[];
            },
            openRecUploadPop() {
                this.receiverUploadVisible = true;
            },
            downloadReceiverInCsv() {
                let param = {id:this.viewId};
                //console.log("this.viewId="+this.viewId);
                download.exportFile(URL.email.downloadReceiverInCsv,param,window.$t('mis.emailSend.emailList'),"csv");
            },
            downloadReceiverInTxt() {
                let param = {id:this.viewId};
                download.exportFile(URL.email.downloadReceiverInTxt,param,window.$t('mis.emailSend.emailList'),"txt");
            },
            validateReceiver(receiver) {
                var invalidReceivers = new Array();
                
                var receivers = receiver.replace(/\n/g, ",").split(",");
                for (var i = 0; i < receivers.length; i++) {
                    if (receivers[i].trim().length > 0 && !this.validateEmail(receivers[i].trim())) {
                        invalidReceivers.push(receivers[i].trim());
                    }
                }
                
                return invalidReceivers;
            },
            validateEmail(email) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            // 文件状态改变时的钩子
            attFileChange(file, fileList) {
                this.attachFileList.push(file.raw) ;
            },
            // 文件remove时的钩子
            attHandleRemove(file, fileList) {
                let index = this.attachFileList.indexOf(file);
                this.attachFileList.splice(index,1);
            },
            // 文件上传成功时的钩子
            attHandleSuccess(res, file, fileList) {
                this.$message.success('文件上传成功');
            },
            // 文件上传失败时的钩子
            attHandleError(err, file, fileList) {
                this.$message.error('文件上传失败');
            },
            attUploadUrl:function(){
                // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
                return ""
            },
            attUploadFile() {
                /*
                if (this.attachFileList.length === 0){
                    this.$message.warning('请上传文件');
                } else {
                    this.closeAttUploadPop();
                }*/
                this.closeAttUploadPop();
            }, 
            attDelAllFile() {
                this.attachFileList=[];
            },
            /*关闭弹窗*/
            closeAttUploadPop() {
                this.attachUploadVisible = false;
            },
            openAttUploadPop() {
                this.attachUploadVisible = true;
            },
            initAttachment() {
                axios.get(URL.email.getAttachmentList+"?id="+this.viewId,{
                        headers: {
                            'Authorization': getToken(getQueryString('label')),
                        },
                    }).then(
                        res=>{
                            if(res.data.code==0){
                                this.sentAttachments = res.data.result;
                            }else{
                                this.$message.error(res.data.message);
                            }
                        },err =>{
                            this.$message.error(err.message);
                        }
                    );
            },
            downloadAttachment(attachId, filename) {
                let param = {id:attachId};
                download.exportFile(URL.email.downloadAttachment,param,filename.replace(".pdf",""),"pdf");
            },
        },
        data () {
            return {
                pageType: '',
                isView: false,     
                allowSubmit: false,      
                isSubmitting: false, 
                receiverUploadVisible:false,
                receiverUploadLimitNum: 1,  
                receiverUploadFileList: [],  
                viewId: '',  
                attachUploadVisible:false,
                attachFileList: [],
                sentAttachments: [],
                emdData: {
                    editorPath: '/editormd/',
                    editorConfig: {
                            path: '/editormd/lib/',   // Autoload modules mode, codemirror, marked... dependents libs path
                            width            : "100%",
                            height           : 640,
                            imageUpload      : true,
                            crossDomainUpload: true,
                            imageUploadURL   : URL.email.uploadImgForEmail,
                            imageFormats     : ["jpg", "jpeg", "gif", "png", "bmp", "webp", "doc", "xls", "csv", "zip", "txt"],
                            toolbarAutoFixed : false,
                            readOnly         : false,
                            onload           : function() {},
                    },			
                },
                form:{
                    id: '',
                    templateId: '',
                    title: '',
                    receiver: '',
                    channelId: '',
                    sender: '',
                },
                templateList:{},
                channelList:{},
                rules: {
                    title: [
                    { required: true, message: "邮件标题不能为空", trigger: "blur" }
                    ],
                    content: [
                    { required: true, message: "邮件内容不能为空", trigger: "blur" }
                    ],
                    receiver: [
                    { required: true, message: "收件人不能为空", trigger: "blur" }
                    ],
                    sender: [
                    { required: true, message: "寄件人不能为空!!要选择有电邮地址的通道!!", trigger: "blur" }
                    ],
                },
            }
        }
    }
</script>

<style>
  li {
    list-style: inherit;
  }
</style>